import { fetchSaltclickIdentityToken } from '../clients/fetchSaltclickIdentityToken';
import {
  fetchOpenSaltclickConversationIds,
  fetchSaltclickScrt2AccessToken,
} from '../clients/saltclickScrt2Client';

export interface IListOpenSaltclickConversationIdsArgs {
  /** From `SALTCLICK_CHAT_CONFIG` — the same values the widget is init'd with. */
  scrt2Url: string;
  orgId: string;
  deploymentName: string;
}

/**
 * What Salesforce still lists open for this account — the read half of
 * `closeOpenSaltclickConversations`, without the deletes.
 *
 * It answers the one question the four end nets cannot: they all watch the widget, so
 * they catch every end the widget is told about and none that it is not. An agent closing
 * a conversation from their console while this page was somewhere else fires nothing here,
 * and the widget resumes from web storage on its next open — into the "Conversation ended"
 * dead end this ticket exists to remove. Only the conversation list knows, and reading it
 * is a REST call rather than a client API.
 *
 * Not the pre-`init` sweep that was tried and rejected. That closed everything open, which
 * took live conversations away; this closes nothing and only reports, so the caller can
 * act on the one id the widget is actually holding.
 *
 * Rejects when a hop fails. Callers must treat that as "no answer" rather than as "no
 * conversation": an empty list is what says a conversation is gone.
 */
export const listOpenSaltclickConversationIds = async ({
  scrt2Url,
  orgId,
  deploymentName,
}: IListOpenSaltclickConversationIdsArgs): Promise<string[]> => {
  const identityToken = await fetchSaltclickIdentityToken();

  const accessToken = await fetchSaltclickScrt2AccessToken({
    scrt2Url,
    orgId,
    deploymentName,
    identityToken: identityToken.token,
  });

  return fetchOpenSaltclickConversationIds({ scrt2Url, accessToken });
};
